import { useEffect, useState } from "react";
import {
  Sparkles,
  Search,
  GitCompare,
  Calculator,
  BadgeEuro,
  Lightbulb,
} from "lucide-react";

const TASKS = [
  { id: "analizar", label: "Analizando tu descripción", icon: Sparkles },
  { id: "buscar", label: "Buscando partidas en el catálogo", icon: Search },
  { id: "comparar", label: "Comparando con proyectos similares", icon: GitCompare },
  { id: "cantidades", label: "Calculando cantidades y mediciones", icon: Calculator },
  { id: "precios", label: "Ajustando precios de referencia", icon: BadgeEuro },
  { id: "sugerencias", label: "Preparando sugerencias", icon: Lightbulb },
];

const TOTAL_MS = 2400;
const STEP_MS = TOTAL_MS / (TASKS.length - 1);

export default function MotorThinkingOverlay({ visible }) {
  const [activo, setActivo] = useState(0);

  useEffect(() => {
    if (!visible) {
      setActivo(0);
      return undefined;
    }
    setActivo(0);
    const timeouts = [];
    for (let i = 1; i < TASKS.length; i++) {
      const id = setTimeout(() => setActivo(i), Math.round(i * STEP_MS));
      timeouts.push(id);
    }
    return () => timeouts.forEach(clearTimeout);
  }, [visible]);

  if (!visible) return null;

  const tarea = TASKS[Math.min(activo, TASKS.length - 1)];
  const Icon = tarea.icon;

  return (
    <div
      className="absolute inset-0 z-10 rounded-md overflow-hidden"
      data-testid="motor-thinking-overlay"
      data-step={tarea.id}
    >
      <div className="absolute inset-0 rx-thinking-bg" />
      <div className="relative h-full w-full px-5 py-4 flex items-center gap-4">
        <span className="relative inline-flex items-center justify-center w-12 h-12 rounded-full bg-white/15 text-white shrink-0 rx-thinking-ring">
          <Icon key={tarea.id} className="w-5 h-5 rx-thinking-icon" />
        </span>
        <div className="flex-1 min-w-0">
          <div className="text-[11px] uppercase tracking-widest text-white/70 font-bold">
            Generando presupuesto con IA · paso {activo + 1} de {TASKS.length}
          </div>
          <div
            key={tarea.id}
            className="font-display font-bold text-white text-lg leading-tight rx-thinking-text"
            data-testid="motor-thinking-label"
          >
            {tarea.label}
            <RxDots />
          </div>
          <div className="mt-2 flex items-center gap-1.5">
            {TASKS.map((t, idx) => (
              <span
                key={t.id}
                data-testid={`motor-task-dot-${t.id}`}
                data-state={
                  idx < activo ? "done" : idx === activo ? "active" : "pending"
                }
                className={`h-1 rounded-full transition-all duration-500 ${
                  idx < activo
                    ? "w-6 bg-white"
                    : idx === activo
                      ? "w-10 bg-white"
                      : "w-3 bg-white/30"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function RxDots() {
  return (
    <span className="inline-flex ml-1 align-baseline">
      <span className="rx-thinking-dot" />
      <span className="rx-thinking-dot" />
      <span className="rx-thinking-dot" />
    </span>
  );
}
